module.exports = __webpack_public_path__ + "img/room.347cc27c.svg";